// extracted by mini-css-extract-plugin
export default {"component":"Loader__component___a3Eex"};